import { LanguageConfig, LanguageInfo } from '@orion-platform/core';
import { environment } from '@orion/environment';
import { StorageKeys } from '../features/scm/material-management/v1/types';

/**
 * Resolves the currently active language for the application.
 * @returns {LanguageInfo} The active language configuration.
 */
export const getActiveLanguage = (): LanguageInfo => {
  const language: LanguageConfig = environment.language;
  const languages: LanguageInfo[] = language.languages;

  const savedLangCode = localStorage.getItem(StorageKeys.LANGUAGE);
  return languages.find((l): boolean => l.code === savedLangCode) ?? language.default;
};
